import { cn } from "@/shared/utils/cn";
import Center from "../Base/Center";

const PosButton = ({
  children,
  isActive = false,
  className,
  ...props
}: any) => {
  return (
    <Center
      className={cn(
        "flex-1 h-14 md:h-16 px-4 cursor-pointer whitespace-nowrap mr-1 font-semibold text-2xl rounded-[0.5rem] tracking-[0.02rem]",
        isActive
          ? "bg-primary/10 border border-primary"
          : "bg-white border-none",
        className
      )}
      {...props}
    >
      {children}
    </Center>
  );
};

export default PosButton;
